module.exports = __webpack_public_path__ + "static/media/menuStar.afe138ba.svg";